import { ReactNode } from 'react'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import { alpha } from '@mui/material/styles'

export type MarkProps = {
	children: ReactNode,
	title: string,
}

/**
 * Inline marker for a degraded-state cell — a subtle warning-tinted tag with a tooltip
 * explaining why the data is incomplete or approximate. Keeps a degraded row readable
 * instead of showing a blank or broken cell.
 */
export default function Mark( { children, title }: MarkProps ) {
	return (
		<Tooltip title={title} arrow>
			<Box
				component="span"
				sx={{
					display: 'inline-flex',
					alignItems: 'center',
					gap: 0.5,
					px: 0.75,
					py: 0.125,
					borderRadius: 0.5,
					fontSize: 11,
					lineHeight: 1.5,
					whiteSpace: 'nowrap',
					cursor: 'help',
					color: 'warning.dark',
					bgcolor: ( theme ) => alpha( theme.palette.warning.main, 0.14 ),
				}}
			>
				{children}
			</Box>
		</Tooltip>
	)
}
